import { statusFormatterWithMap, textFormatter } from "components/Common/formatter";
import ButtonGroup from "components/Common/buttons/ButtonGroup";
import arrow from "assets/images/svg/arrow-white.svg";
import editCalendar from "assets/images/svg/Edit Calendar.svg";
import removeIcon from "assets/images/svg/remove-customers.svg";
import clearIcon from "assets/images/svg/clear.svg";
import NGIDropdownButton from "components/Common/buttons/NGIDropdownButton";
import { MODE } from "pages/settings/firmware-whitelists/constants";

export const firmwareWhitelistColumns = (tenantMapping, onEdit) => [
  {
    title: "Type",
    dataIndex: "depot",
    render: (row, data) => (
      <div>
        {tenantMapping[data.tenant]}
        {!row
          ? statusFormatterWithMap(
              "DEFAULT",
              {
                DEFAULT: {
                  color: "#0085FF",
                  backgroundColor: "#0085FF26",
                },
              },
              {
                fontSize: 8,
                marginLeft: 5,
              }
            )
          : `-${row}`}
      </div>
    ),
  },
  {
    title: "Tenant",
    dataIndex: "tenant",
    render: row => tenantMapping[row],
  },
  {
    title: "Meter Type",
    dataIndex: "meterType",
    render: textFormatter,
  },
  {
    title: "FIRMWARE VERSIONS QTy",
    dataIndex: "firmwares",
    render: row => row.length,
  },

  {
    dataIndex: "",
    title: "",
    width: "4%",
    render: (_, data) => (
      <NGIDropdownButton
        position="left"
        toggleEl={<ButtonGroup icon={arrow} />}
        menuItems={[
          ...(data.depot
            ? [
                {
                  label: "Clear Whitelist",
                  subLabel: "Allow any firmware for depot",
                  icon: clearIcon,
                  callback: () => onEdit(data, MODE.CLEAR),
                },
              ]
            : []),
          {
            label: "View/Edit Whitelist",
            subLabel: "Edit list of firmware versions",
            icon: editCalendar,
            callback: () => onEdit(data, MODE.EDIT),
          },
          {
            label: "Delete Whitelist",
            subLabel: "Permanently remove default whitelist",
            icon: removeIcon,
            callback: () => onEdit(data, MODE.REMOVE),
          },
        ]}
      />
    ),
  },
];
